import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCalendarAlt, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import DateRangeSelector from '../daterangepicker/DateRangeSelector';

const SupervisorDashboardFilters = ({ filterby, setFilterBy,selectedDateRange,setSelectedDateRange,isDateRangeOpen, setIsDateRangeOpen}) => {
    const [activeFilter, setActiveFilter] = useState('All');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
   const trigger=()=>{
    setSelectedDateRange(selectedDateRange)
   }
 
    const options = ["Supervisor", "Company", "Status"];
    const filters = [
        { label: 'All', count: 8 },
        { label: 'Pending', count: 9 },
    ];

    return (
        <div className="flex flex-wrap items-center justify-between p-4 gap-4 relative">
            {/* Left Side: Arrow Icon and Filter Buttons */}
            <div className="flex flex-wrap items-center gap-4">
                {/* Left Arrow Icon */}
                <div className="p-2 bg-[#F3F4F6] rounded-md">
                    <FontAwesomeIcon icon={faArrowLeft} className="text-xl text-black" />
                </div>

                {/* Filter Buttons */}
                <div className="flex flex-wrap gap-2">
                    {filters.map((filter) => (
                        <button 
                            key={filter.label}
                            onClick={() => setActiveFilter(filter.label)}
                            className={`min-w-[80px] px-4 py-2 rounded-md transition-colors duration-200 ${
                                activeFilter === filter.label 
                                    ? 'bg-[#900] text-white' 
                                    : 'bg-[#F3F4F6] text-black'
                            }`}
                        >
                            {filter.label} ({filter.count})
                        </button>
                    ))}
                </div>
            </div>

            {/* Right Side: Submit Timesheet Button, Date, and Settings Icon */}
            <div className="flex flex-wrap items-center gap-4">
                {/* Date Picker Toggle Button */}
                <button 
                    onClick={() => setIsDateRangeOpen(!isDateRangeOpen)}
                    className="flex items-center justify-center gap-2 h-10 px-4 py-2 rounded-[6px] border border-[#E4E4E7] bg-white text-black relative"
                    style={{ minWidth: 'fit-content' }}
                >
                    <FontAwesomeIcon icon={faCalendarAlt} className="text-black" />
                    {new Intl.DateTimeFormat('en-US', { month: 'short', day: '2-digit', year: 'numeric' }).format(selectedDateRange.startDate)} - 
                    {new Intl.DateTimeFormat('en-US', { month: 'short', day: '2-digit', year: 'numeric' }).format(selectedDateRange.endDate)}
                </button>

                {/* Date Range Picker Popover */}
                {isDateRangeOpen && (
                    <div className="absolute top-16 right-0 z-50   p-4">
                        <DateRangeSelector
                        onSubmit={()=>setIsDateRangeOpen(false)}
                            selectedDateRange={selectedDateRange}
                            setSelectedDateRange={(range) => {
                                setSelectedDateRange(range);
                                console.log(range)
                                // setIsDateRangeOpen(false); // Close after applying
                            }}
                        />
                    </div>
                )}

                {/* Dropdown Filter */}
                <div className="relative w-44">
                    <button
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                        className="flex items-center justify-between w-full h-10 p-2 border border-gray-300 bg-white rounded-md"
                    >
                        <span className="text-gray-700">{filterby}</span>
                        <FontAwesomeIcon icon={faChevronDown} className="text-gray-500" />
                    </button>
                    {isDropdownOpen && (
                        <ul className="absolute w-full bg-white border border-gray-300 rounded-md mt-1 shadow-md z-40">
                            {options.map((option) => (
                                <li
                                    key={option}
                                    onClick={() => {
                                        setFilterBy(option);
                                        setIsDropdownOpen(false);
                                    }}
                                    className="p-2 text-start hover:bg-gray-100 cursor-pointer text-gray-700"
                                >
                                    {option}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SupervisorDashboardFilters;
